/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-29 18:03:51
 * @LastEditors: linxi
 * @LastEditTime: 2023-01-10 16:36:02
 */
import { Button, Space, TableColumnType } from 'antd'
import React from 'react'
import styles from '../OutpatientStatistics.module.css'
import { ColDef } from 'ag-grid-community'
import { getSexData } from '../../../models/ToothHome'
import { getAge } from '../../../utils/StringUtils'
import { getMaskPhone } from '../../../models/phone'
import { decrypt } from '../../../models/m'

export const AGColumns = (
  startIndex?: any,
  onAction?: (
    action: string,
    t: any,
  ) => void,
  columnList?: any,
  HZGLCKHZSJHData?: boolean,
): ColDef[] => {

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'name': //患者姓名
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: function getpatientName(params: any) {
              const t = params.data;
              if (params.node.rowPinned) {
                return ''
              }
              return (
                <Button
                  type='link'
                  onClick={(e) => {
                    e.stopPropagation()
                    onAction && onAction('patientDetail', t)
                  }}
                >
                  {t?.name}
                </Button>
              );
            },
          };
        case 'sex': //性别
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data
              return getSexData(Number(t.sex)) || '-';
            },
          };
        case 'ageYear': //年龄
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return getAge(t?.ageYear, t?.ageMonth);
            },
          };
        case 'phone': //联系电话
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.phone ? (!HZGLCKHZSJHData ? getMaskPhone(decrypt(t?.phone)) : decrypt(t?.phone)) : '-';
            },
          };
        case 'birthday': //出生年月
        case 'doctorName': //医生
        case 'sendSmsTime': //短信发送时间
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              return val ? val : '';
            },
          };
        case 'action':
          return {
            ...item,
            cellStyle: { textAlign: 'center', display: 'flex', alignItems: 'center' },
            cellRendererFramework: function getActionName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              // 确保只在合适的状态下显示退费按钮，避免重复显示
              return (
                <div>
                  <Button
                    type='link'
                    onClick={(e) => {
                      e.stopPropagation()
                      onAction && onAction('send', t)
                    }}
                  >
                    发送短信
                  </Button>
                </div>
              )
            }
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
          };
      }
    })
  )
}
